import { motion, useReducedMotion } from "framer-motion";
import { getIcon } from "@/lib/icons";

const POSITION_STYLES = {
  "top-left": "absolute -left-2 top-4 sm:top-6",
  "top-right": "absolute -right-2 top-4 sm:top-6",
  "bottom-left": "absolute -left-2 bottom-10",
  "bottom-right": "absolute -right-2 bottom-10",
};

const VARIANT_ICON = {
  soft: "bg-[#FFEEE6] text-[#D94A14]",
  orange: "bg-[#F35A1F] text-white",
};

const HIDDEN_ON_MOBILE = "hidden sm:flex";

export const FloatingBanners = ({ banners = [], testIdPrefix = "floating-banner" }) => {
  const reduce = useReducedMotion();

  if (!Array.isArray(banners) || banners.length === 0) return null;

  return (
    <>
      {banners.map((b, i) => {
        if (b.visible === false) return null;
        const Icon = getIcon(b.icon || "Sparkles");
        const pos = POSITION_STYLES[b.position] || POSITION_STYLES["top-left"];
        const iconCls = VARIANT_ICON[b.variant] || VARIANT_ICON.soft;
        const rotate = (i % 2 === 0 ? -6 : 5);
        const Comp = reduce ? "div" : motion.div;
        const motionProps = reduce
          ? {}
          : {
              initial: { y: 0, rotate },
              animate: { y: [0, i % 2 === 0 ? -10 : 8, 0] },
              transition: {
                duration: 5.5 + (i % 3) * 0.8,
                repeat: Infinity,
                ease: "easeInOut",
                delay: 0.2 * i,
              },
            };

        return (
          <Comp
            key={`${b.position}-${b.label}-${i}`}
            data-testid={`${testIdPrefix}-${i}`}
            data-position={b.position}
            data-variant={b.variant}
            className={`${pos} z-10 ${HIDDEN_ON_MOBILE} items-center gap-2 rounded-2xl border border-[hsl(var(--border))] bg-white px-3 py-2 pf-shadow-sm`}
            {...motionProps}
          >
            <span className={`inline-flex h-7 w-7 items-center justify-center rounded-lg ${iconCls}`}>
              <Icon className="h-3.5 w-3.5" />
            </span>
            <span className="pf-mono text-[10px] uppercase tracking-wider text-[hsl(var(--muted-foreground))] whitespace-nowrap">
              {b.label}
            </span>
          </Comp>
        );
      })}
    </>
  );
};

export default FloatingBanners;
